import AdaptiveImage from "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "315d0b805409001a4134cbd96eb4d3b1.jpg","uri@2x": __webpack_public_path__ + "03bc158b2019095890635ff1aacc6294.jpg","uri@3x": __webpack_public_path__ + "d55a77c9a4c0708f9dc5c23886123dd6.jpg",
    width: 320,
    height: 568
});